

import { NoProfilePermissions } from '../../store/modules/permissions/NoProfile';
import { AuthAction, AuthState } from './types';

export const AUTH_SET_PERMISSIONS = 'AUTH_SET_PERMISSIONS';
export const AUTH_SET_USER = 'AUTH_SET_USER';
export const AUTH_LOADING_USER_DATA_ACTION = 'AUTH_LOADING_USER_DATA_ACTION';
export const AUTH_LOAD_USER_DATA_SUCCESS_ACTION = 'AUTH_LOAD_USER_DATA_SUCCESS_ACTION';
export const AUTH_LOAD_USER_DATA_ERROR_ACTION = 'AUTH_LOAD_USER_DATA_ERROR_ACTION';
export const LOCAL_STORAGE_ID_TOKEN = 'LOCAL_STORAGE_ID_TOKEN';
export const LOCAL_STORAGE_REDIRECT_URI = 'LOCAL_STORAGE_REDIRECT_URI'
export const LOCAL_STORAGE_ACCESS_TOKEN = 'LOCAL_STORAGE_ACCESS_TOKEN'

export const AUTH_API_VERSION = '1';

const INITIAL_STATE: AuthState = {
  loadingUserData: false,
  accessToken: null,
  tokenType: null,
  userPermissions: NoProfilePermissions,
  userData: null,
};

export default function AuthReducer(
  state: AuthState = INITIAL_STATE,
  action: AuthAction
): AuthState {
  switch (action.type) {
    case AUTH_SET_PERMISSIONS:
      return {
        ...state,
        userPermissions: action.payload,
      };
    case AUTH_SET_USER:
      return {
        ...state,
        accessToken: action.payload.access_token,
        tokenType: action.payload.token_type,
        userData: action.payload,
      };
    case AUTH_LOADING_USER_DATA_ACTION:
      return {
        ...state,
        loadingUserData: action.payload,
      };
    case AUTH_LOAD_USER_DATA_ERROR_ACTION:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}
